'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALIAS_DISPLAY_NAME = exports.ALIAS_TYPE = undefined;

var _boardConstants = require('../boards/boardConstants');

var ALIAS_TYPE = exports.ALIAS_TYPE = 'ALIAS';
var ALIAS_DISPLAY_NAME = exports.ALIAS_DISPLAY_NAME = _boardConstants.BOARD_DISPLAY_NAME;


//////////////////
// WEBPACK FOOTER
// ./src/common/alias/aliasConstants.js
// module id = 241
// module chunks = 0